import React, { FC } from 'react';

import { WithColor } from '@styles/colors';
import { CentralColumnProps, NCFileVersionsProps, RightColumnProps } from '@components/ncFileVersions/types';
import CentralColumn from './CentralColumn';
import RightColumn from './RightColumn';

export interface WideColumnsProps
  extends WithColor,
    Pick<NCFileVersionsProps, 'ncFile' | 'selectedItem'>,
    Pick<CentralColumnProps, 'onSendToMachine' | 'onMarkThisVersionAsInactive' | 'comparisonMode' | 'onEnterComparisonMode' | 'versionsToCompare' | 'onExitComparisonMode' | 'onStartComparison'> {
  selectedVersion: RightColumnProps['selectedVersion'] | undefined;
  favoriteOrLatest: CentralColumnProps['selectedVersion'] | undefined;
  hasMultipleVersions: boolean;
}

const WideColumns: FC<WideColumnsProps> = ({
  C,
  ncFile,
  selectedItem,
  selectedVersion,
  favoriteOrLatest,
  hasMultipleVersions,
  onSendToMachine,
  onMarkThisVersionAsInactive,
  comparisonMode,
  onEnterComparisonMode,
  versionsToCompare,
  onExitComparisonMode,
  onStartComparison,
}) => {
  if (!ncFile) return null;

  return (
    <>
      {selectedVersion && favoriteOrLatest && hasMultipleVersions && (
        <CentralColumn
          C={C}
          selectedVersion={selectedVersion}
          ncFile={ncFile}
          twoColumnView={false}
          visible
          onSendToMachine={onSendToMachine}
          onMarkThisVersionAsInactive={onMarkThisVersionAsInactive}
          comparisonMode={comparisonMode}
          onEnterComparisonMode={onEnterComparisonMode}
          hasMultipleVersions={hasMultipleVersions}
          versionsToCompare={versionsToCompare}
          onExitComparisonMode={onExitComparisonMode}
          onStartComparison={onStartComparison}
        />
      )}
      {selectedVersion && (
        <RightColumn
          selectedItem={selectedItem}
          C={C}
          ncFile={ncFile}
          visible={true}
          selectedVersion={selectedVersion}
          onSendToMachine={onSendToMachine}
        />
      )}
    </>
  );
};

export default WideColumns;
